export const kLSRLClass = "lsrl"
export const kLSRLType = "LSRL"
export const kLSRLPrefix = "ADRN"
export const kLSRLLabelKey = "DG.Inspector.graphLSRL"
export const kLSRLUndoAddKey = "DG.Undo.graph.showLSRL"
export const kLSRLRedoAddKey = "DG.Redo.graph.showLSRL"
export const kLSRLUndoRemoveKey = "DG.Undo.graph.hideLSRL"
export const kLSRLRedoRemoveKey = "DG.Redo.graph.hideLSRL"
